import {
  SE_CHEQUE_GET_BY_ESCONTRACT_ID,
  SE_CHEQUE_GET_BY_ESCONTRACT_ID_SUCCESS,
  SE_CHEQUE_GET_BY_ESCONTRACT_ID_ERROR,
  SE_CHEQUE_GET_BY_ID,
  SE_CHEQUE_GET_BY_ID_SUCCESS,
  SE_CHEQUE_GET_BY_ID_ERROR,
  SE_CHEQUE_ADD_NEW,
  SE_CHEQUE_ADD_NEW_SUCCESS,
  SE_CHEQUE_ADD_NEW_ERROR,
  SE_CHEQUE_EDIT,
  SE_CHEQUE_EDIT_SUCCESS,
  SE_CHEQUE_EDIT_ERROR,
  SE_CHEQUE_DELETE,
  SE_CHEQUE_DELETE_SUCCESS,
  SE_CHEQUE_DELETE_ERROR,
} from '../actions';

const initialState = {
  items: [],
  item: null,
  loading: false,
  error: null,
};

export default function reducerState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SE_CHEQUE_DELETE:
    case SE_CHEQUE_EDIT:
    case SE_CHEQUE_ADD_NEW:
    case SE_CHEQUE_GET_BY_ID:
    case SE_CHEQUE_GET_BY_ESCONTRACT_ID:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SE_CHEQUE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
        loading: false,
      };

    case SE_CHEQUE_GET_BY_ESCONTRACT_ID_SUCCESS:
      return {
        ...state,
        items: payload,
        loading: false,
      };

    case SE_CHEQUE_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
        items: state.items.concat(payload),
      };

    case SE_CHEQUE_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        item: payload,
        error: null,
      };

    case SE_CHEQUE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(c => c.id !== payload),
        error: null,
      };

    case SE_CHEQUE_GET_BY_ESCONTRACT_ID_ERROR:
    case SE_CHEQUE_GET_BY_ID_ERROR:
    case SE_CHEQUE_ADD_NEW_ERROR:
    case SE_CHEQUE_EDIT_ERROR:
    case SE_CHEQUE_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
